import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Space } from "@stenajs-webui/core";
import { MenuButton } from "@stenajs-webui/elements";
import { PropsWithChildren, useState } from "react";

interface FilterSectionProps {
  label: string;
  leftIcon?: IconDefinition;
  isOpen: boolean;
  setIsOpen: () => void;
}

export const FilterSection = ({
  label,
  leftIcon,
  children,
  isOpen,
  setIsOpen,
}: PropsWithChildren<FilterSectionProps>) => {
  return (
    <>
      <MenuButton
        label={label}
        leftIcon={leftIcon}
        expandable
        expanded={isOpen}
        selected={isOpen}
        onClick={() => setIsOpen()}
      >
        {children}
      </MenuButton>
      {isOpen && <Space />}
    </>
  );
};
